import firebase from "firebase/compat/app";

import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBnumzgpCnKlkjlIKuMK5HCFfI9lMbO56E",
  authDomain: "scrobits-website-184d1.firebaseapp.com",
  projectId: "scrobits-website-184d1",
  storageBucket: "scrobits-website-184d1.appspot.com",
  messagingSenderId: "561202584010",
  appId: "1:561202584010:web:aa4d710ecc641535e21733",
  measurementId: "G-8YV8P4HB9B",
};

const firebase_ = firebase.initializeApp(firebaseConfig);
firebase.firestore();

export default firebase_;
export const firestore = firebase.firestore();
// export const storage = firebase.storage();
